<template>
  <nav class="d-flex flex-row">
    <section v-if="!toggleMenu" class="largeMenu">
      <ul class="">
        <li @click="toggleMenu = !toggleMenu">
          <span><font-awesome-icon :icon="['fas', 'chevron-circle-left']"></font-awesome-icon></span>
          <span>Réduire le menu</span>
        </li>
        <router-link tag="li" to="/">
          <span><font-awesome-icon :icon="['fas', 'tachometer-alt']"></font-awesome-icon></span>
          <span>Tableau de bord</span>
        </router-link>
        <router-link tag="li"
                     :active-class="'active'"
                     :class="menu.highlight ? 'highlight':''"
                     :to="menu.path"
                     :key="menu.id"
                     v-for="(menu) in getMenu.filter( (m) => m.sousMenu.exists === false)">
          <span><font-awesome-icon :icon="menu.icon"></font-awesome-icon></span>
          <span>{{ menu.titre.charAt(0).toUpperCase() + menu.titre.slice(1) }}</span>
        </router-link>
      </ul>
      <div>&nbsp;</div>
    </section>
    <section v-if="toggleMenu" class="smallMenu">
      <ul class="">
        <li @click="toggleMenu = !toggleMenu">
          <span><font-awesome-icon :icon="['fas', 'chevron-circle-right']"></font-awesome-icon></span>
        </li>
        <router-link tag="li" to="/">
          <span><font-awesome-icon :icon="['fas', 'tachometer-alt']"></font-awesome-icon></span>
        </router-link>
        <router-link tag="li"
                     :class="menu.highlight ? 'highlight':''"
                     :to="menu.path"
                     :key="menu.id"
                     v-for="(menu) in getMenu.filter( (m) => m.sousMenu.exists === false)">
          <span><font-awesome-icon :icon="menu.icon"></font-awesome-icon></span>
        </router-link>
      </ul>
      <div>&nbsp;</div>
    </section>
  </nav>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
export default {
  name: "Navigation",
  data () {
    return {
      toggleMenu: false
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
  },
  computed: {
    ...mapGetters([
        'getMenu'
    ])
  },
  beforeCreate() {},
  watch: {},
  created() {
    (window.outerWidth < 600) ? this.toggleMenu = true : this.toggleMenu = false
  },
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
}
</script>

<style lang="scss" scoped>
.highlight{
  background-color: var(--color-light-black, rgba(0, 0, 0, .5));
}
.active{
  background-color: var(--color-white, rgba(255, 255, 255, 1));
  color: var(--color-black, rgba(0, 0, 0, 1));
}
nav {
  & > section.largeMenu{
    background: radial-gradient(circle, var(--color-light-golden-orange, rgba(204, 204, 0, .5)), var(--color-golden-orange, rgba(204, 204, 0, 1)));
    color: var(--color-white, rgba(255, 255, 255, 1));
    width: 220px;
    //
    & > ul{
      list-style: none;
      padding-left: 0;
      & > li:first-child{
        border-top: 1px solid var(--color-white, rgba(255, 255, 255, 1));
      }
      & > li{
        padding-top: .4rem;
        padding-bottom: .4rem;
        border-bottom: 1px solid var(--color-white, rgba(255, 255, 255, 1));
        display: flex;
        flex-direction: row;
        font-size: medium;
        & > span{
          display: block;
          text-align: center;
          align-self: center;
        }
        & > span:nth-child(1){
          width: 20%;
          font-size: large;
        }
        & > span:nth-child(2){
          width: 75%;
          text-align: left;
        }
        & > span:nth-child(3){
          display: none;
          color: var(--color-black, rgba(0, 0, 0, 1));
          margin-left: 20px;
        }
      }
      & > li:hover{
        background-color: var(--color-white, rgba(255, 255, 255, 1));
        color: var(--color-black, rgba(0, 0, 0, 1));
        cursor: pointer;
        & > span:nth-child(3){
          display: block;
        }
      }
      //
      & > li.item-with-menu{
        & > ul{
          display: none;
          background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
          color: var(--color-white, rgba(255, 255, 255, 1));
          list-style: none;
          position: absolute;
          padding-left: 0;
          width: 230px;
          left: 220px;
          margin-top: -6px;
          z-index: 3;
          & > li:first-child{
            border-top: 1px dashed var(--color-white, rgba(255, 255, 255, 1));
          }
          & > li{
            padding-top: .4rem;
            padding-bottom: .4rem;
            border-bottom: 1px dashed var(--color-white, rgba(255, 255, 255, 1));
            display: flex;
            flex-direction: row;
            font-size: medium;
            & > span{
              display: block;
              text-align: center;
              align-self: center;
            }
            & > span:nth-child(1){
              width: 20%;
              font-size: large;
            }
            & > span:nth-child(2){
              width: 75%;
              text-align: left;
            }
            & > span:nth-child(3){
              color: var(--color-maya-blue, rgba(100, 181, 246, 1));
              margin-left: 20px;
            }
          }
          & > li:first-child:hover{
            border-top: 1px dashed var(--color-curious-blue, rgba(34, 134, 195, 1));
          }
          & > li:hover{
            background-color: var(--color-white, rgba(255, 255, 255, 1));
            color: var(--color-curious-blue, rgba(34, 134, 195, 1));
            cursor: pointer;
            border-bottom: 1px dashed var(--color-curious-blue, rgba(34, 134, 195, 1));
          }
        }
      }
      & > li.item-with-menu:hover{
        & > ul{
          display: block;
        }
      }
    }
  }
  & > section.smallMenu{
    background: radial-gradient(circle, var(--color-light-golden-orange, rgba(204, 204, 0, .5)), var(--color-golden-orange, rgba(204, 204, 0, 1)));
    color: var(--color-white, rgba(255, 255, 255, 1));
    width: 50px;
    //
    & > ul{
      list-style: none;
      padding-left: 0;
      & > li:first-child{
        border-top: 1px solid var(--color-white, rgba(255, 255, 255, 1));
      }
      & > li{
        padding-top: .4rem;
        padding-bottom: .4rem;
        border-bottom: 1px solid var(--color-white, rgba(255, 255, 255, 1));
        display: flex;
        flex-direction: row;
        font-size: medium;
        & > span{
          display: block;
          text-align: center;
          align-self: center;
        }
        & > span:nth-child(1){
          padding-left: 1rem;
          font-size: large;
        }
        & > span:nth-child(2){
          text-align: left;
        }
        & > span:nth-child(3){
          display: none;
          color: var(--color-black, rgba(0, 0, 0, 1));
          margin-left: 20px;
        }
      }
      & > li:hover{
        background-color: var(--color-white, rgba(255, 255, 255, 1));
        color: var(--color-black, rgba(0, 0, 0, 1));
        cursor: pointer;
        & > span:nth-child(3){
          display: block;
        }
      }
      //
      & > li.item-with-menu{
        & > ul{
          display: none;
          background: radial-gradient(circle, var(--color-light-golden-orange, rgba(204, 204, 0, .5)), var(--color-golden-orange, rgba(204, 204, 0, 1)));
          color: var(--color-white, rgba(255, 255, 255, 1));
          list-style: none;
          position: absolute;
          padding-left: 0;
          width: 230px;
          left: 50px;
          margin-top: -6px;
          z-index: 3;
          & > li:first-child{
            border-top: 1px dashed var(--color-white, rgba(255, 255, 255, 1));
          }
          & > li{
            padding-top: .4rem;
            padding-bottom: .4rem;
            border-bottom: 1px dashed var(--color-white, rgba(255, 255, 255, 1));
            display: flex;
            flex-direction: row;
            font-size: medium;
            & > span{
              display: block;
              text-align: center;
              align-self: center;
            }
            & > span:nth-child(1){
              font-size: large;
            }
            & > span:nth-child(2){
              text-align: left;
            }
            & > span:nth-child(3){
              color: var(--color-black, rgba(0, 0, 0, 1));
              margin-left: -55px;
            }
          }
          & > li:first-child:hover{
            border-top: 1px dashed var(--color-light-dark-gray, rgba(51, 51, 51, .5));
          }
          & > li:hover{
            background-color: var(--color-white, rgba(255, 255, 255, 1));
            color: var(--color-black, rgba(0, 0, 0, 1));
            cursor: pointer;
            border-bottom: 1px dashed var(--color-light-dark-gray, rgba(51, 51, 51, .5));
          }
        }
      }
      & > li.item-with-menu:hover{
        & > ul{
          display: block;
        }
      }
    }
  }
}
@media (min-width: 576px) {
}

@media (min-width: 768px) {
}

@media (min-width: 992px) {
}

</style>



// WEBPACK FOOTER //
// src/components/shared/Navigation.vue